import env from "$lib/env";
import { get } from "svelte/store";
import settings from "$lib/state/settings";

export const currentApiURL = () => {
    const processingSettings = get(settings).processing;
    const customInstanceURL = processingSettings.customInstanceURL;

    // keep any path prefix (e.g. https://host/api) instead of reducing to origin;
    // trailing slashes are stripped because callers append "/session" etc.
    const apiBase = (url: string) => new URL(url).toString().replace(/\/+$/, "");

    if (processingSettings.enableCustomInstances && customInstanceURL.length > 0) {
        return apiBase(customInstanceURL);
    }

    return apiBase(env.DEFAULT_API!);
}
